import styled from 'styled-components/macro';

const StyledOverlay = styled.div`
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: flex-start;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 30000;
  padding: 1.2rem;
`;

export default StyledOverlay;
